import { render, staticRenderFns } from "./add-rule.vue?vue&type=template&id=12259058&scoped=true&"
import script from "./add-rule.vue?vue&type=script&lang=ts&"
export * from "./add-rule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12259058",
  null
  
)

export default component.exports